import styled from 'styled-components';
import ReactSlider from 'react-slider';
import { COLOR_ORANGE } from '../../../assets/styles/colors';

export const SliderSC = styled(ReactSlider)`
  height: 4px;
  background: rgb(56, 54, 68);
  border-radius: 32px;
  margin: 10px 0 10px 0;
  .more-top {
    margin: 20px 0 10px 0;
  }

  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    border-radius: 32px;
    left: 0;
    width: ${({ max, value }) => `${(value / max) * 100}%`};
    max-width: 100%;
    height: 4px;
    background: ${COLOR_ORANGE};
    transform: translateY(-50%);
  }

  .sl-handle {
    z-index: 1;
    cursor: pointer;
    outline: none;
    height: 16px;
    width: 16px;
    background: linear-gradient(270deg, #fab535 0%, #f7931e 100%);
    margin-top: 1px;
    border-radius: 50%;
    border: none;
    transform: translateY(-50%);
    &.custom {
      left: ${({ max, value }) => `calc(${(value / max) * 100}% - 16px)`} !important;
    }
  }
`;
